<template>
    <div class="list_nav_wrap toggle-nav">
        <h1 class="list_nav_title">
            <label>颜色</label>
        </h1>
        <div class="sc-color">
            <template v-for="item in list">
                <a v-if="item.value !== 4"
                    @click="doSelect(item.value)"
                    :title="item.name" 
                    :style="{
                        'background-color': item.color
                    }">
                    <i class="color-active  #if($!formBean.color!=11)#end"
                        :class="{
                            hidden: (~~active !== item.value)
                        }"></i>
                    <span class="color-hover hidden"></span>
                </a>
                <a v-else
                    @click="doSelect(item.value)"
                    :title="item.name"
                    style="height: 13px; border-top: 1px solid #e5e5e7; border-bottom: 1px solid #e5e5e7;"
                    :style="{
                        'background-color': item.color
                    }">
                    <i class="color-active  #if($!formBean.color!=11)#end"
                        :class="{
                            hidden: (~~active !== item.value)
                        }"></i>
                    <span class="color-hover hidden"></span>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    export default {
        data() {
            return {
                active: locationObj.search.get('color'),
                list: [{
                    value: 11,
                    name: '紫色',
                    color: '#79386a'
                }, {
                    value: 6,
                    name: '蓝色',
                    color: '#396bb3'
                }, {
                    value: 12,
                    name: '绿色',
                    color: '#98cb68'
                }, {
                    value: 10,
                    name: '黄色',
                    color: '#fbdc04'
                }, {
                    value: 15,
                    name: '橙色',
                    color: '#f37920'
                }, {
                    value: 5,
                    name: '红色',
                    color: '#ca2128'
                }, {
                    value: 17,
                    name: '粉红色',
                    color: '#FEBECC'
                }, {
                    value: 7,
                    name: '咖啡色',
                    color: '#724624'
                }, {
                    value: 9,
                    name: '香槟色',
                    color: '#e7d3ae'
                }, {
                    value: 4,
                    name: '白色',
                    color: '#ffffff'
                }, {
                    value: 3,
                    name: '黑色',
                    color: '#000000'
                }, {
                    value: 2,
                    name: '深灰色',
                    color: '#888787'
                }, {
                    value: 1,
                    name: '银灰色',
                    color: '#efecec'
                }]
            };
        },
        methods: {
            doSelect(value) {
                locationObj.s('color', value).s('index', null).go();
            }
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavColor.vue?5fbe5a08